import dayjs from "dayjs";
import * as React from "react";
import { CLOVIS_STANDART_DATE_FORMAT } from "~/config/dayjs";
import { notificationsMap } from "~/config/user/user-notifications/notificationsMap";
import type { UserNotification } from "~/config/user/user-notifications/utils/types";
import { useUser } from "~/config/user/UserProvider";
import { ListItem } from "~/design-system/List";
import { Text } from "~/design-system/Text";
import { ReadNotifWrapper } from "../NotificationsListDesktop";
import { AvatarFromUserId } from "./AvatarFromUserId/AvatarFromUserId";

type NotificationListItemProps = {
  data: UserNotification;
};

const PROJECT_SPREADSHEET_IMPORT_REJECTED_NOTIFICATION_TYPE =
  "ORG/PROJECT_SPREADSHEET_IMPORT_REJECTED";

const NotificationListItem = (props: NotificationListItemProps) => {
  const { user } = useUser();
  const shouldWrapContent =
    props.data.type === PROJECT_SPREADSHEET_IMPORT_REJECTED_NOTIFICATION_TYPE;

  return (
    <ListItem
      avatar={
        <ReadNotifWrapper
          isRead={props.data.read_at !== null}
          display="flex"
          alignItems="center"
        >
          <AvatarFromUserId size="small" userId={props.data.creator_id} />
        </ReadNotifWrapper>
      }
      title={
        <ReadNotifWrapper isRead={props.data.read_at !== null}>
          <Text
            size="small"
            truncate={shouldWrapContent ? undefined : true}
            css={
              shouldWrapContent
                ? {
                    lineHeight: "1.25rem",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                  }
                : undefined
            }
          >
            {
              notificationsMap[props.data.type]({ user }, props.data as never)
                .content
            }
          </Text>
        </ReadNotifWrapper>
      }
      subtitle={
        <ReadNotifWrapper isRead={props.data.read_at !== null}>
          <Text size="small">
            {dayjs(props.data.created_at).format(CLOVIS_STANDART_DATE_FORMAT)}
          </Text>
        </ReadNotifWrapper>
      }
    />
  );
};

export { NotificationListItem };
